export default __webpack_public_path__ + "static/media/Icon awesome-filter.c3e3f7e4.svg";